<adapt-dialog [maxWidth]="900"
              [disallowCancel]="!!dialogData.disallowCancel"
              [fitHeight]="true">
    <h3 adapt-dialog-title>{{ titleAction }} {{ ProductLabel }} subscription</h3>
    <ng-container adapt-dialog-content>
        @if (isIntroPage) {
            <adapt-styled-implementation-kit [articleId]="StartSubscriptionArticle"
                                             contentStyle="embedded"></adapt-styled-implementation-kit>
        }

        @if (!isIntroPage) {
            @if (promptingEula) {
                <div class="d-flex flex-column gap-3 h-100">
                    <p class="m-0 border-bottom pb-3">
                        <strong> Please read the {{ ProductLabel }} customer license agreement below, tick the checkbox and accept on behalf
                            of {{ organisation?.name }}.</strong>
                    </p>
                    <adapt-eula (loadedChange)="eulaLoaded = $event"></adapt-eula>
                    <dx-check-box class="d-block border-top pt-3"
                                  text="I have read and agree to the terms of the customer license agreement"
                                  [disabled]="!eulaLoaded"
                                  [value]="eulaAccepted"
                                  (valueChange)="eulaAccepted = $any($event)"></dx-check-box>
                </div>
            }
            @if (!promptingEula) {
                <div class="d-flex flex-column flex-lg-row-reverse gap-3">
                    @if (account) {
                        <div class="d-flex flex-column flex-grow-1">
                            @if (!account.extensions.isFree && account.extensions.isBilledUsingCreditCard) {
                                <adapt-display-pricing-breakdown [account]="account"
                                                                 [resetBillingCycle]="true"></adapt-display-pricing-breakdown>
                                <div class="small ms-2 d-flex flex-column gap-2">
                                    @if (account.extensions.canResumeSubscriptionWithoutCharge()) {
                                        <span>
                                            Your previous subscription will remain active until
                                            <strong>{{ account.nextSubscriptionInvoiceDate | adaptDate }}</strong>. You will not be charged
                                            again until after this date.
                                        </span>
                                    }
                                </div>
                            } @else {
                                <div class="alert alert-secondary">
                                    @if (account.extensions.isBilledUsingCreditCard) {
                                        Your credit card will not be charged with your free account.
                                    } @else {
                                        Please note that your credit card will not be charged as your payment method is set to 'invoice.'
                                        You will receive a detailed invoice for your account and can make payment according to the terms
                                        specified.
                                    }
                                </div>
                            }
                        </div>
                    }
                    @if (account.extensions.hasSubscriptionCost) {
                        <div class="credit-card-column">
                            <h4>Credit card details</h4>
                            <ng-container *adaptLoading="cardDetailsLoading">
                                @if (!cardDetails) {
                                    <adapt-update-credit-card-details [updateCreditCardInput]="creditCardInput"
                                                                      (cardSet)="cardSetCorrectly = $event"></adapt-update-credit-card-details>
                                }
                                @if (cardDetails) {
                                    <adapt-configure-credit-card [(cardDetails)]="cardDetails"
                                                                 [organisationId]="creditCardInput.organisationIdentifier.organisationId"
                                                                 [eulaToken]="creditCardInput.organisationIdentifier.eulaToken"
                                                                 [allowEditing]="true"
                                                                 (cardIsSet)="cardSetCorrectly = $event"></adapt-configure-credit-card>
                                }
                            </ng-container>
                        </div>
                    }
                </div>
            }
        }
    </ng-container>

    @if (isIntroPage) {
        <div adapt-dialog-footer
             class="w-100 d-flex gap-1">
            @if (!dialogData.showIntroOnly) {
                <button adaptButton="workflowNext"
                        class="ms-auto"
                        (click)="isIntroPage = false"
                        data-test="next-page-button">Next</button>
                @if (!dialogData.disallowCancel) {
                    <button adaptButton="iconlessCancel"
                            (click)="cancel()"></button>
                }
            } @else {
                <button adaptButton="primary"
                        class="ms-auto"
                        (click)="cancel()"
                        data-test="next-page-button">Select subscription</button>
            }
        </div>
    } @else {
        <div adapt-dialog-footer
             class="w-100 d-flex">
            <button adaptButton="workflowPrevious"
                    (click)="isIntroPage = true">Back</button>
            @if (promptingEula) {
                <adapt-standard-dialog-buttons adapt-dialog-footer
                                               (cancelClick)="cancel()"
                                               saveButtonPreset="primary"
                                               [saveBlockingClick]="acceptEula"
                                               [saveIsDisabled]="!eulaAccepted"
                                               [hideCancelButton]="!!dialogData.disallowCancel"
                                               saveText="Accept"></adapt-standard-dialog-buttons>
            } @else {
                <adapt-standard-dialog-buttons adapt-dialog-footer
                                               (cancelClick)="cancel()"
                                               saveButtonPreset="primary"
                                               [saveBlockingClick]="saveAndClose"
                                               [saveIsDisabled]="(!cardSetCorrectly || !account.contactName || !account.contactEmail) && account.extensions.hasSubscriptionCost"
                                               [hideCancelButton]="!!dialogData.disallowCancel"
                                               [saveText]="titleAction + ' subscription'"></adapt-standard-dialog-buttons>
            }
        </div>
    }
</adapt-dialog>
